import { CapabilitiesIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

export const APP_CONFIG_PLATFORM_ADMIN: AppConfig = {
  name: 'Platform Admin',
  applicationKey: 'internal-platform-admin',
  type: 'internal',
  appSlugForEngagement: AppSlugs.PlatformAdmin,
  rootPath: '/platform-admin',
  Icon: CapabilitiesIcon,
  descriptionLong:
    'Manage HouseCanary Platform settings such as Roles, Feature-Flags, Token TTLs, API Components, and Zuora Usage Uploads',
  descriptionShort: 'Manage Platform and Security Settings',
};

export const VIEW_PATHS_PLATFORM_ADMIN = {
  // Self Serve
  SELF_SERVE: 'self-serve',
  SELF_SERVE_PLANS: 'self-serve/plans',
  SELF_SERVE_COUPONS: 'self-serve/coupons',
  SELF_SERVE_COUPON: 'self-serve/coupons/:couponCode',
  // Capability System
  APPLICATIONS: 'applications',
  APPLICATION: 'application/:applicationKey',
  CAPABILITIES: 'capabilities',
  CAPABILITY: 'capability', // capabilityKey is passed as a search param because they can have slashes in them
  ENTITLEMENTS: 'entitlements',
  ENTITLEMENT: 'entitlement/:entitlementKey',
  DEVFLAGS: 'devflags',
  DEVFLAG: 'devflag/:devflagKey',
  ACCROLES: 'accroles',
  ACCROLE: 'accrole/:roleKey',
  // Proxy
  PROXY: 'proxy',
} as const;
